export const pathsSchema = {
  index: "/",
  login: "/login",
  signInRedirect: "/signin-oidc",
  cognitoCallback: "/callback",
  signOutRedirect: "/signout-callback-oidc",
  servicing: {
    customers: {
      index: "/servicing/customers",
      detail: "/servicing/customers/:customerId",
      edit: "/servicing/customers/:customerId/edit-customer",
      accounts: {
        index: "/servicing/customers/:customerId",
        detail: "/servicing/customers/:customerId/accounts/:accountId",
        addAccount: "/servicing/customers/:customerId/accounts/add-account",
        balanceAdjustment:
          "/servicing/customers/:customerId/accounts/:accountId/balance-adjustment",
        editAuthorization:
          "/servicing/customers/:customerId/accounts/:accountId/edit-authorization/:transactionId",
        newInstrument:
          "/servicing/customers/:customerId/accounts/:accountId/new-instrument",
        replaceInstrument:
          "/servicing/customers/:customerId/accounts/:accountId/instrument/:instrumentId/replace-instrument",
        transactions: {
          detail:
            "/servicing/customers/:customerId/accounts/:accountId/transactions/:transactionId",
        },
        instruments: {
          index:
            "/servicing/customers/:customerId/accounts/:accountId/instruments",
          detail:
            "/servicing/customers/:customerId/accounts/:accountId/instruments/:instrumentId",
        },
        detailLedger:
          "/servicing/customers/:customerId/accounts/:accountId/ledger/:ledgerId",
        credit: {
          detail: "/servicing/customers/:customerId/accounts/:accountId/credit",
        },
      },
    },
  },
  clients: {
    index: "/clients",
    subClients: "/sub-clients",
    detail: "/clients/:id",
    add: "/clients/add",
    addNewClient: "/clients/add-new-client",
    edit: "/clients/:id/edit-client",
    instrumentProducts: "/instrument-products",
    subClient: "/clients/:id/sub-clients",
  },
  subClients: {
    index: "/clients/:id/sub-clients",
    detail: "/clients/:id/sub-clients/:subClientId",
    add: "/clients/:id/sub-clients/add",
    edit: "/clients/:id/sub-clients/:subClientId/edit-client",
    createAccountHolder:
      "/clients/:id/sub-clients/:subClientId/account-holders/create",
  },
  instrumentProducts: {
    index: "/instrument-products",
    detail: "/instrument-products/:id",
    edit: "/instrument-products/:id/edit",
  },
  financialProducts: {
    index: "/financial-products",
    detail: "/financial-products/:id",
    edit: "/financial-products/:id/edit",
    createLedgers: "/financial-products/:id/create-ledgers",
    ledgerDetail: "/financial-products/:id/ledgers/:ledgerId",
  },
  sandboxAdmin: {
    audit: "/sandbox-audit-log",
    userManagement: "/sandbox-user-management",
    domainLists: "/sandbox-domain-lists",
  },
  addNewFinancialCreditProduct: {
    index: "/credit/add-new-financial-product",
  },
  addNewFinancialDebitProduct: {
    index: "/debit/add-new-financial-product",
  },
  addNewInstrumentProduct: {
    index: "/add-new-instrument-product",
  },
  continueWithInstrumentProduct: {
    index: "/continue-with-instrument-product",
  },
  keyManagement: {
    index: "/key-management/keys",
    product: "/key-management/keys/product/:productId",
    detail: "/key-management/keys/:keyId",
    import: "/key-management/keys/import",
    binRanges: "/key-management/keys/bin-ranges",
  },
  documentation: {
    portal: "/documentation-portal/getting-started/overview",
  },
  portal: {
    index: "/home",
    search: "/search",
    transactionDetail: "/search/transaction/:transactionId/detail",
    cardDetail: "/search/card/:publicToken/detail",
    groupUsage: "/search/card/:publicToken/detail/groupUsage",
    paymentTokenDetail:
      "/search/card/:publicToken/detail/paymentToken/:tokenId",
    cardHistory: "/search/card/:publicToken/detail/cardHistory",
    cardTransactionResult: "/search/card/:publicToken",
    transactionResult: "/search/transaction/:transactionId",
    userAdmin: "/user-admin",
    applications: "/applications",
    applicationDetail: "/application/:id",
    certificates: {
      create: "/application/:id/certificate/create",
    },
    featureRequest: "/feature-request",
    faqs: "/faqs",
    calculator: "/calculator",
    panfinder: "/panfinder",
    webhooks: "/webhooks",
    abo: "/automated-back-office/abo",
    disputesAndChargeback: "/automated-back-office/disputes",
    moneyMovement: "/ach",
    sponsorGuard: {
      index: "/sponsor-guard",
      clients: "/sponsor-guard/clients",
      client: "/sponsor-guard/clients/:clientId",
      configuration: "/sponsor-guard/configuration",
      approvals: "/sponsor-guard/approvals",
      auditLogs: "/sponsor-guard/audit-logs",
    },
    organization: {
      index: "/organization",
      inviteUsers: "/organization/invite-users",
      oauthClientCreate: "/organization/oauth-clients/create",
      applications: {
        index: "/organization/applications",
        create: "/organization/applications/create",
        detail: "/organization/applications/:applicationId",
        edit: "/organization/applications/:applicationId/edit",
        oauthClients: {
          index: "/organization/applications/:applicationId/oauth-clients",
          detail:
            "/organization/applications/:applicationId/oauth-clients/:clientId",
          create:
            "/organization/applications/:applicationId/oauth-clients/create",
        },
      },
      security: "/organization/security",
      analytics: "/organization/analytics",
      settings: "/organization/settings",
      support: "/organization/support",
      users: {
        index: "/organization/users",
        directory: "/organization/users/directory",
        create: "/organization/users/create",
        add: "/organization/users/add",
        invite: "/organization/users/invite",
        bulkInvite: "/organization/users/bulk-invite",
        profile: "/organization/users/:userId",
        edit: "/organization/users/:userId/edit",
        groups: "/organization/users/groups",
        groupCreate: "/organization/users/groups/create",
        groupDetail: "/organization/users/groups/:groupId",
        analytics: "/organization/users/analytics",
        roles: "/organization/users/roles",
        settings: "/organization/users/settings",
        configureSso: "/organization/users/sso/configure",
      },
      groups: {
        index: "/organization/groups",
        create: "/organization/groups/create",
        details: "/organization/groups/:groupId",
        edit: "/organization/groups/:groupId/edit",
      },
    },
  },
  auditLog: {
    index: "/audit-log",
  },
  featureRequest: {
    index: "/feature-request",
  },
  demoHub: {
    index: "/demo",
    settings: "settings",
    accountDetail: "accounts/:accountId",
    customerDashboard: "dashboard",
    addTheme: "themes/new",
    editTheme: "themes/:themeId/edit",
    storefront: "/storefront/products",
    ledgerEngine: "/demo/ledger",
    badger: "/demo/badger",
    badgerDebit: "debit",
    badgerDebitStorefront: "debit/storefront",
    badgerTravel: "travel",
    badgerTravelNew: "travel/new",
    badgerTravelCards: "travel/cards",
    badgerTravelTransactions: "travel/transactions",
    badgerTravelLedger: "travel/ledger",
  },
  organizations: {
    index: "/admin/organizations",
    create: "/admin/organizations/create",
    detail: "/admin/organizations/:organizationId",
    dashboard: "/admin/organizations/:organizationId/dashboard",
    edit: "/admin/organizations/:organizationId/settings",
    applications: "/admin/organizations/:organizationId/applications",
    applicationDetail:
      "/admin/organizations/:organizationId/applications/:applicationId",
    technicalConfiguration:
      "/admin/organizations/:organizationId/applications/:applicationId/technical-configuration",
    users: {
      index: "/admin/organizations/:organizationId/users",
      dashboard: "/admin/organizations/:organizationId/users/dashboard",
      directory: "/admin/organizations/:organizationId/users/directory",
      create: "/admin/organizations/:organizationId/users/create",
      invite: "/admin/organizations/:organizationId/users/invite",
      profile: "/admin/organizations/:organizationId/users/:userId",
      edit: "/admin/organizations/:organizationId/users/:userId/edit",
    },
    groups: {
      index: "/admin/organizations/:organizationId/groups",
      create: "/admin/organizations/:organizationId/groups/create",
      details: "/admin/organizations/:organizationId/groups/:groupId",
      edit: "/admin/organizations/:organizationId/groups/:groupId/edit",
    },
    ehiConfiguration: {
      index: "/ehi-configuration",
    },
  },
  commonServices: {
    index: "/common-services",
    clientSpaces: {
      index: "/common-services/client-spaces",
      create: "/common-services/client-spaces/create",
      details: "/common-services/client-spaces/:id",
      dashboard: "/common-services/client-spaces/dashboard",
    },
    referenceData: {
      currencies: {
        index: "/reference-data/currencies",
        create: "/reference-data/currencies/create",
        edit: "/reference-data/currencies/:code/edit",
        detail: "/reference-data/currencies/:code",
      },
    },
  },
  featureFlags: {
    index: "/feature-flags",
  },
  accounts: {
    index: "/accounts",
    addAccount: "/accounts/add-account",
    detail: "/accounts/:accountId/ledger/:ledgerId",
  },
  treasury: {
    offsetAccounts: {
      index: "/treasury/offset-accounts",
      detail: "/treasury/offset-accounts/:id",
    },
  },
  sandbox: {
    index: "/sandbox",
    login: "/sandbox/login",
    forgotPassword: "/sandbox/forgot-password",
    resetPassword: "/sandbox/reset-password",
    verifyEmail: "/sandbox/verify-email",
    explorer: "/sandbox/explorer",
    credentials: "/sandbox/credentials",
    recipes: "/sandbox/recipes",
    recipeDetail: "/sandbox/recipes/:recipeId",
    terms: "/sandbox/terms",
  },
  smartClientDeprecation: {
    index: "/smart-client-deprecation",
    mccPadding: "/smart-client-deprecation/mcc-padding",
    xmlFileDetails: "/smart-client-deprecation/xml-file-details",
    webServiceFeeMaster: "/smart-client-deprecation/web-service-fee-master",
    feesMaster: "/smart-client-deprecation/fees-master",
    webServiceFeesByGroup:
      "/smart-client-deprecation/web-service-fees-by-group",
    recurringFeeSubGroupMaster:
      "/smart-client-deprecation/recurring-fee-sub-group-master",
    groupFeeRecurringMaster:
      "/smart-client-deprecation/group-fee-recurring-master",
    groupRecurringFees: "/smart-client-deprecation/group-recurring-fees",
    feesByGroup: "/smart-client-deprecation/fees-by-group",
    bankMaster: "/smart-client-deprecation/bank-master",
    bank: "/smart-client-deprecation/bank",
    programManagerMaster: "/smart-client-deprecation/program-manager-master",
    institutionMaster: "/smart-client-deprecation/institution-master",
    schemeMaster: "/smart-client-deprecation/scheme-master",
    fraudAndRiskConfigurations:
      "/smart-client-deprecation/fraud-and-risk-configurations",
    productExport: "/smart-client-deprecation/product-export",
    productImport: "/smart-client-deprecation/product-import",
    institutionExport: "/smart-client-deprecation/institution-export",
    productMaster: "/smart-client-deprecation/product-master",
    mccCodeMaster: "/smart-client-deprecation/mcc-code-master",
    currencyMaster: "/smart-client-deprecation/currency-master",
    loadSourceMaster: "/smart-client-deprecation/load-source-master",
    groupLimitMaster: "/smart-client-deprecation/group-limit-master",
    groupLimit: "/smart-client-deprecation/group-limit",
    mccGroupMaster: "/smart-client-deprecation/mcc-group-master",
    mccGroup: "/smart-client-deprecation/mcc-group",
    usageGroupMaster: "/smart-client-deprecation/usage-group-master",
    usageGroupRulesDetails:
      "/smart-client-deprecation/usage-group-rules-details",
    groupCardLinkage: "/smart-client-deprecation/group-card-linkage",
    cardAcceptorListMaster:
      "/smart-client-deprecation/card-acceptor-list-master",
    cardAcceptorListCardAcceptor:
      "/smart-client-deprecation/card-acceptor-list-card-acceptor",
    cardDisallowListMaster:
      "/smart-client-deprecation/card-disallow-list-master",
    cardDisallowListCardAcceptor:
      "/smart-client-deprecation/card-disallow-list-card-acceptor",
  },
};

export const isSandboxPath = (pathname: string) =>
  pathname === pathsSchema.sandbox.index ||
  pathname.startsWith(`${pathsSchema.sandbox.index}/`);
